import React, { useState } from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from './headshot';
import ConversationSettingsComponent from './conversation_settings';

function isObjectEmpty(obj) {
  for(var o in obj) { if (obj.hasOwnProperty(o)) return false; }
  return true;
}

const ParticipantDetails = ({ user, fetchUserDetails }) => {
  if (!user || isObjectEmpty(user)) { return null; }

  const [fetching, setFetching] = useState(false);

  if (!fetching && !user.hasDetailsFromStore) {
    setFetching(true);
    fetchUserDetails(user.slug).then(() => {
      setFetching(false);
    });
  }

  const crossedPaths = () => {
    const { crossedPaths } = user;
    if (!crossedPaths || crossedPaths.length === 0) { return; }

    const rows = crossedPaths.map(event => <div className="crossed-path" key={event.eventSlug}>
      <a href={`/events/${event.eventSlug}`}>{event.eventTitle}</a>
    </div>);

    return (
      <div className="crossed-paths row t5 mb-20">
        <label className="t5 w3">Crossed Paths</label>
        {rows}
      </div>
    );
  }

  return (
    <div className="participant-details col-md-12">

      <div className="headshot row text-center mb-15">
        <img width="100%" src={user.headShotImage} />
      </div>

      <div className="row text-center">
        <span className="t1 w3">{user.displayName}</span>
      </div>

      <div className="row text-center t5 mb-30">
        <span className="t4">{user.companyTitle}</span>
      </div>

      { crossedPaths() }

      <div className="row t5 mb-20">
        <div className="col-xs-6">
          <div className="row">
            <label className="t5 w3">Events Attended</label>
            <div className="t5">{user.attendedCount}&nbsp;</div>
          </div>
        </div>
        <div className="col-xs-6">
          <div className="row">
            <label className="t5 w3">Events Hosted</label>
            <div className="t5">{user.hostedCount}&nbsp;</div>
          </div>
        </div>
      </div>

      <div className="row t5 mb-20">
        <label className="t5 w3">Member Since</label>
        <div className="t5">{user.memberSince}&nbsp;</div>
      </div>

      <div className="row t5 mb-20">
        <label className="t5 w3">Profile</label>
        <div>
          <a className="t5" href={`/users/${user.slug}`}>voray.com/users/{user.slug}&nbsp;</a>
        </div>
      </div>
    </div>
  );
};

ParticipantDetails.propTypes = {
  user: PropTypes.object
};

export default ParticipantDetails;
